<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    if (window.location.host === 'webpre.hzwxbz999.cn') {
      this.$toast('注意：当前环境为测试环境！');
    }
    
  }
}
</script>
<style>
#app {
  width: 100%;
  height: 100%;
}
</style>